import React, {useEffect, useState} from 'react';
import Select from "react-select";
import {requestGetInviteJobMailTemps} from "@app/services/InviteJobMailTemplateService";
import {MailTempType} from "@pages/email/common/Constant";

const SelectDVTJCUVMailTemplateContent = (props) => {
    const [tempOptions, setTempOptions] = useState([]);
    const [selectTemplate, setSelectTemplate] = useState({});
    const [templateType, setTemplateType] = useState(MailTempType.DVTJCUV_INVITE_EMAIL);

    const {selectedId, tempType, onSelect} = props

    const fetchDVTJCUVMailTemplates = async (type) => {
        const res = await requestGetInviteJobMailTemps({
            search_conditions: {
                unlimited: true,
                template_type: type
            }
        });
        const signatureList = res.content.mail_templates
        const tempOptionList = []
        signatureList.forEach(item => {
            const tempOption = {value: item.id, label: item.name, content: item.signature_body}
            tempOptionList.push(tempOption)

            if (item.id === selectedId) {
                setSelectTemplate(tempOption)
            }
        })
        setTempOptions([...tempOptionList]);
    }

    const onSelectTemplate = (tempOption) => {
        setSelectTemplate(tempOption)
        if (onSelect) {
            onSelect(tempOption)
        }
    }

    useEffect(() => {
        if (selectedId) {
            tempOptions.forEach(item => {
                console.log('change mail template ID')
                if (Number(item.value) === selectedId) {
                    setSelectTemplate({...item})
                }
            })
        }
    }, [selectedId, tempOptions]);
    useEffect(() => {
        // const strUserLogin = localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)
        // if (!userLoginInfo.id && strUserLogin) {
        //     const userLogin = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
        //     setUserLoginInfo(userLogin)
        //
        //     fetchDVTJCUVMailTemplates()
        // }
        // Chỉ get template của user đang login (đã xử lý phía BE)
        setTemplateType(tempType)
        fetchDVTJCUVMailTemplates(templateType).then()
    },[templateType]);

    return (
        <>
            <div className='form-group'>
                <label className={'w-100'}>Mail template</label>
                <Select options={tempOptions}
                        placeholder={"Chọn mail template"}
                        value={selectTemplate || ''}
                        onChange={values => {
                            onSelectTemplate(values);
                        }}
                />
            </div>
        </>
    )
}

export default SelectDVTJCUVMailTemplateContent;
